import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-left",
  "use": "icon-chevron-left-usage",
  "viewBox": "0 0 8 15",
  "content": "<symbol viewBox=\"0 0 8 15\" fill=\"\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-chevron-left\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.72754 0.643799L7.08374 0L0 7.08374L7.08374 14.1675L7.72754 13.5237L1.2876 7.08374L7.72754 0.643799Z\" fill=\"\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol